const xliffVersionType = {
  xliff12: '1',
  xliff2: '2'
};

export default xliffVersionType;
